import { /* getConversionStatus */ getOrder, getOrders, OrderDetail, patchOrder } from '@ttstr/api';

import { ThunkActionCreator } from '.';

export const ORDER_STATUS_REQUESTED = 'ORDERS.ORDER_STATUS_REQUESTED';
export const ORDER_STATUS_RECEIVED = 'ORDERS.ORDER_STATUS_RECEIVED';
export const ORDER_STATUS_FAILED = 'ORDERS.ORDER_STATUS_FAILED';
export const ORDER_STATUS_DONE = 'ORDERS.ORDER_STATUS_DONE';

export const ORDERS_REQUESTED = 'ORDERS.ORDERS_REQUESTED';
export const ORDERS_RECEIVED = 'ORDERS.ORDERS_RECEIVED';
export const ORDERS_FAILED = 'ORDERS.ORDERS_FAILED';
export const ORDERS_DONE = 'ORDERS.ORDERS_DONE';

export const ORDER_REQUESTED = 'ORDERS.ORDER_REQUESTED';
export const ORDER_RECEIVED = 'ORDERS.ORDER_RECEIVED';
export const ORDER_FAILED = 'ORDERS.ORDER_FAILED';
export const ORDER_DONE = 'ORDERS.ORDER_DONE';

export const requestOrders: ThunkActionCreator = () => async (dispatch, getState) => {
  const {
    Customer: { loggedIn },
  } = getState();
  if (!loggedIn) throw new Error('Not logged in');

  dispatch({
    type: ORDERS_REQUESTED,
  });

  try {
    const orders = await getOrders();
    dispatch({
      type: ORDERS_RECEIVED,
      payload: {
        orders,
      },
    });
  } catch (error) {
    dispatch({
      type: ORDERS_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: ORDERS_DONE,
    });
  }
};

export const requestOrder: ThunkActionCreator = (orderId: number, xtoken?: string) => async (dispatch) => {
  dispatch({
    type: ORDER_REQUESTED,
  });

  try {
    const order = await getOrder(orderId, xtoken);
    dispatch({
      type: ORDER_RECEIVED,
      payload: {
        order,
      },
    });
  } catch (error) {
    dispatch({
      type: ORDER_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: ORDER_DONE,
    });
  }
};

export const updateOrder: ThunkActionCreator = (
  order: Partial<OrderDetail>,
  orderId: number,
  xtoken?: string
) => async (dispatch) => {
  dispatch({
    type: ORDER_REQUESTED,
  });

  try {
    const updatedOrder = await patchOrder(order, orderId, xtoken);
    dispatch({
      type: ORDER_RECEIVED,
      payload: {
        order: updatedOrder,
      },
    });
  } catch (error) {
    dispatch({
      type: ORDER_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: ORDER_DONE,
    });
  }
};
